import { useState } from "react";
import { FiX, FiKey } from "react-icons/fi";
import toast from "react-hot-toast";
import api from "../../utils/api";
import styles from "./Modal.module.css";

const ChangePasswordModal = ({ onClose }) => {
  const [form, setForm] = useState({ current: "", newPw: "", confirm: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setError("");
    if (!form.current) return setError("Enter your current password");
    if (form.newPw.length < 6) return setError("New password must be at least 6 characters");
    if (form.newPw !== form.confirm) return setError("Passwords don't match");

    setSaving(true);
    try {
      await api.put("/auth/update-profile", {
        currentPassword: form.current,
        newPassword: form.newPw,
      });
      toast.success("🔐 Password changed successfully!");
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || "Failed to change password");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Change Password</h3>
          <button className={styles.closeBtn} onClick={onClose}><FiX size={18} /></button>
        </div>

        <div className={styles.formFields} style={{ padding: "20px 18px" }}>
          <div className={styles.field}>
            <label>Current Password</label>
            <input
              type="password"
              className="input-field"
              autoComplete="new-password" placeholder="Enter current password"
              value={form.current}
              onChange={(e) => setForm({ ...form, current: e.target.value })}
            />
          </div>
          <div className={styles.field}>
            <label>New Password</label>
            <input
              type="password"
              className="input-field"
              autoComplete="new-password" placeholder="Min 6 characters"
              value={form.newPw}
              onChange={(e) => setForm({ ...form, newPw: e.target.value })}
            />
          </div>
          <div className={styles.field}>
            <label>Confirm New Password</label>
            <input
              type="password"
              className="input-field"
              autoComplete="new-password" placeholder="Repeat new password"
              value={form.confirm}
              onChange={(e) => setForm({ ...form, confirm: e.target.value })}
            />
          </div>
          {error && (
            <p style={{ fontSize: 12, color: "var(--danger)", marginTop: 4 }}>{error}</p>
          )}
        </div>

        <div className={styles.saveFooter}>
          <button className={styles.saveBtn} onClick={handleSave} disabled={saving}>
            <FiKey size={15} />
            {saving ? "Changing..." : "Change Password"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordModal;
